import { render, staticRenderFns } from "./unauthorizedUser.html?vue&type=template&id=08483d86&external"
import script from "./unauthorizedUser.vue?vue&type=script&lang=js"
export * from "./unauthorizedUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports